import {AppActions, RootState} from 'app/rootReducer'
import Toast from 'components/Basic/Toast'
import {translations} from 'definitions'
import {
  HTTP_STATUS_CODE,
  DEFAULT_DATE_WITH_TIME_FORMAT,
} from 'definitions/constant'
import {parseAnalyticsDetailRequestPayload} from 'features/Analytics/helpers'
import {format} from 'date-fns'
import {Epic, StateObservable} from 'redux-observable'
import {concat, from, of} from 'rxjs'
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators'
import {AnalyticsService} from 'services/api'
import {
  downloadViolationsLogs,
  downloadViolationsLogsFailure,
  downloadViolationsLogsSuccess,
} from './actions'

const violationsLogsDownloadEpic: Epic<
  AppActions,
  AppActions,
  StateObservable<RootState>
> = (action$, state$) =>
  action$.pipe(
    filter(downloadViolationsLogs.match),
    switchMap(() => {
      const requestBody = {
        ...parseAnalyticsDetailRequestPayload(state$),
        dateTime: format(new Date(), DEFAULT_DATE_WITH_TIME_FORMAT),
      }
      return from(
        AnalyticsService.getAnalyticsDetail(requestBody, {download: true}),
      ).pipe(
        mergeMap(resp => {
          const {data, status} = resp
          const {fileUrl = ''} = data?.response || {}
          if (status === HTTP_STATUS_CODE.NO_CONTENT) {
            Toast({
              message: translations.NO_RESULTS_AVAILABLE,
              type: 'info',
              customId: 'violations-download-no-results-toast',
            })
          }
          return [downloadViolationsLogsSuccess(fileUrl)]
        }),
        catchError(() => concat(of(downloadViolationsLogsFailure()))),
      )
    }),
  )

const violationsLogsDownloadFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(downloadViolationsLogsFailure.match),
    tap(() => Toast({message: translations.UNKNOWN_ERROR, type: 'error'})),
    ignoreElements(),
  )

export const violationsLogsDownloadEpics = [
  violationsLogsDownloadEpic,
  violationsLogsDownloadFailureEpic,
]
